// extracted by mini-css-extract-plugin
export default {"wrapper":"page-loader_wrapper__izW68"};